<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <div class="container-fluid p-4">

        <div *ngIf="processResult.state === 'KO'"
            class="d-flex flex-column justify-content-center align-items-center w-100">

            <div
                class="bg-danger-lighter-color d-flex flex-column justify-content-center align-items-start w-100 p-3 mb-2">
                <span class="fs-5">Se ha producido un error al crear la inscripción.</span>
                <span class="fs-5">Por favor, vuelva a intentarlo. Si el problema persiste, no dude en ponerse en
                    contacto con nosotros</span>
            </div>

        </div>

        <div *ngIf="processResult.state === 'OK'"
            class="d-flex flex-column justify-content-center align-items-center w-100">

            <div
                class="bg-primary-light-color d-flex flex-column justify-content-center align-items-start w-100 p-3 mb-2">
                <span class="fs-5">{{processResult.message}}</span>
            </div>

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2 mt-4">
                <span class="fs-5">!!!Gracias por inscribir a <strong>{{this.enrollment.student.name}} {{this.enrollment.student.surname}}</strong> en el <strong>{{this.enrollment.edition.campusName}}</strong>!!! </span>
                <span class="fs-5 mt-2"> A continuación te indicamos los datos de tu reserva:</span> 
            </div>

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-3">
                <span class="text-primary-color fw-bolder">Código de inscripción:</span>
                <span class="fs-4 fw-bolder">{{this.enrollment.code}}</span>
            </div>

            <!-- Participante -->
            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-3">
                <div class="w-100 mb-1">
                    <span class="text-primary-color fw-bolder">Participante:</span>
                </div>
                <table class="student-table table table-bordered">
                    <tbody>
                        <tr>
                            <td class="table-title-grey"><span>Nombre: </span></td>
                            <td><span>{{ this.enrollment.student.name }} {{ this.enrollment.student.surname }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-grey"><span>Fecha de nacimiento: </span></td>
                            <td><span>{{ this.enrollment.student.birthDate | date: 'dd-MM-yyyy'}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Cursos -->
            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-3">
                <div class="w-100 mb-1">
                    <span class="text-primary-color fw-bolder">Cursos:</span>
                </div>
                <table class="courses-table table table-bordered">
                    <tbody *ngFor="let class of this.enrollment.classes">
                        <tr>
                            <td colspan="2" class="table-title-grey fw-bold text-start">
                                <span>{{ class.schedule.description }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span>Curso</span> </td>
                            <td><span>{{ class.courseName }} [{{ class.classification.name }}]</span></td>
                        </tr>
                        <tr *ngFor="let extra of class.extraServices">
                            <td><span>Extra</span></td>
                            <td><span>{{ extra.displayName }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Payment info -->
            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-3">
                <div class="w-100 mb-1">
                    <span class="text-primary-color fw-bolder">El coste del Campus para la inscripción realizada
                        es:</span>
                </div>
                <table class="payment-info-table table table-bordered">
                    <tbody>
                        <tr>
                            <td class="table-title-grey"><span>Coste cursos (sin descuentos): </span></td>
                            <td class="fw-bold text-end"><span>{{ this.enrollment.paymentInfo.totalPriceCourses }}
                                    €</span></td>
                        </tr>
                        <tr>
                            <td class="table-title-grey"><span>Descuento: </span></td>
                            <td class="fw-bold text-end"><span>-{{ this.enrollment.paymentInfo.discountPriceCourses }}
                                    €</span></td>
                        </tr>
                        <tr *ngIf="this.enrollment.paymentInfo.totalPriceExtras > 0">
                            <td class="table-title-grey"><span>Coste extras: </span></td>
                            <td class="fw-bold text-end"><span>{{ this.enrollment.paymentInfo.totalPriceExtras }}
                                    €</span></td>
                        </tr>
                        <tr>
                            <td class="table-title-accent fs-5"><span>Total a pagar: </span></td>
                            <td class="table-title-accent fs-5 fw-bold text-end"><span>{{
                                    this.enrollment.paymentInfo.finalPriceEnrollment }} €</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex flex-column justify-content-start align-items-start w-100 mb-3">

                <div class="alert alert-warning w-100 fs-5 mb-2">
                    <span class="text-decoration-underline">IMPORTANTE</span><br />
                    <span>Esta inscripción es <strong>PROVISIONAL</strong>.</span><br />
                    <div class="w-100">
                        <ul>
                            <li>Si aplica algún descuento, envíe a la dirección <strong> info@campustecnologicodelicai.com </strong> la documentación acreditativa. (Familia numerosa, exalumno Comillas, etc).</li>
                            <li>Si en el plazo de 15 días no ha completado este proceso la inscripción será dada de baja.</li>
                            <li>Si tiene cualquier duda o dificultad, por favor contáctenos, estamos a su disposición en <strong>info@campustecnologicodelicai.com</strong> ó <strong>630000990</strong>.</li>  
                        </ul>
                    </div>
                </div>

            </div>

            <div class="d-flex flex-column justify-content-center align-items-center w-100 mb-3">

                <button pButton class="btn button-primary-color" title="Ver detalle"    
                    (click)="goToDetail(enrollment.code)">
                    <span class="fs-5">Ir a página de detalle para efectuar el pago</span>
                </button>

            </div>

            <div class="d-flex flex-column justify-content-center align-items-center w-100 mb-3">
                <span class="fs-4 text-primary-color-dark fw-bolder">Muchas gracias por tu interés. ¡¡Esperamos verte en
                    el {{ this.enrollment.edition.campusName }}!!</span>
            </div>

        </div>

    </div>

</div>